var PREFIX = 'le';
/**
 * @internal
 * @param suffix suffix to suffix
 */
export function cssClass(suffix) {
    if (!suffix) {
        return PREFIX;
    }
    return PREFIX + "-" + suffix;
}
export var CSS_CLASS_LOADING = cssClass('loading');
export var CSS_CLASS_FROZEN = cssClass('frozen');
export var CSS_CLASS_HIDDEN = cssClass('hidden');
export var CSS_CLASS_MULTI = cssClass('multi');
export var CSS_CLASS_EVEN = cssClass('even');
export var CSS_CLASS_SHIFTED = cssClass('shifted');
export var CSS_CLASS_SCROLLBAR_TESTER = cssClass('scrollbar-tester');
export var CSS_CLASS_HEADER = cssClass('header');
export var CSS_CLASS_BODY = cssClass('body');
export var CSS_CLASS_FOOTER = cssClass('footer');
export var CSS_CLASS_THEAD = cssClass('thead');
export var CSS_CLASS_TBODY = cssClass('tbody');
export var CSS_CLASS_TR = cssClass('tr');
export var CSS_CLASS_TH = cssClass('th');
export var CSS_CLASS_TD = cssClass('td');
export var CSS_CLASS_SCROLLING = cssClass('scrolling');
export var CSS_CLASS_ROW_ANIMATION = cssClass('row-animation');
//# sourceMappingURL=index.js.map